import React from 'react';
import { Icon, IconType, Theme } from '@routific/hive';

const SwitchViewIcon: React.FC = () => {
  return <Icon icon={IconType.ExpandDown} style={{ color: Theme.Colors.primary5 }} />;
};

export default SwitchViewIcon;
